import React, { useState } from 'react'
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import { useSelector, useDispatch } from "react-redux";
import { CURRENT_MONTH_ENABLE_DAY } from "../constants/common";
import { useYearMonth } from './YearMonth';
import { setSelectedMonthYear } from "../slices/commonReducer";
import {
    Row,
    Col,
    Breadcrumb,
} from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";
function DatePickerComponent({ hideDatepicker, title }) {
    const { selectedYear, setSelectedYear } =
        useYearMonth();
    const dispatch = useDispatch();
    const dayjsPackage = dayjs();
    const { selectedMonth: initialMonth } = useSelector((state) => state.common);
    const [selectedMonth, setSelectedMonth] = useState(dayjsPackage.month(initialMonth - 1));
    const [monthString, setMonthString] = useState(dayjsPackage.month(initialMonth - 1).format("MMMM"));
    const { client_id } = useParams();

    const handleMonthChange = (date, dateString) => {
        if (!dateString) {
            const defaultMonth = dayjsPackage.date() > CURRENT_MONTH_ENABLE_DAY ? dayjsPackage.month() : dayjsPackage.month() - 1;
            setSelectedMonth(dayjsPackage.month(defaultMonth));
            setMonthString(dayjsPackage.month(defaultMonth).format("MMMM"));
            setSelectedYear(dayjsPackage.year());
        } else {
            const selectedYear = dayjs(date).year();
            setSelectedYear(selectedYear)
            setSelectedMonth(date);
            setMonthString(dateString);
        }
    };

    const disabledDate = (current) => {
        const disabledMonths = ['2024-01', '2024-03', '2022-01'];
        const currentMonth = dayjsPackage.month();
        const currentYear = dayjsPackage.year();
        const formattedCurrent = current.format('YYYY-MM');

        if (
            current.year() > currentYear || // Future years
            (current.year() === currentYear && current.month() > currentMonth) || // Future months in the current year
            (current.year() === currentYear && current.month() === currentMonth && dayjsPackage.date() < CURRENT_MONTH_ENABLE_DAY) // Current month before the 25th
        ) {
            return true;
        }

        // Disable specific previous months
        if (disabledMonths.includes(formattedCurrent)) {
            //return true;
        }

        return false;
    };

    function submitDate() {
        const monthMap = {
            January: 1,
            February: 2,
            March: 3,
            April: 4,
            May: 5,
            June: 6,
            July: 7,
            August: 8,
            September: 9,
            October: 10,
            November: 11,
            December: 12,
        };
        const monthNumber = monthMap[monthString];
        setSelectedMonth(dayjsPackage.month(monthNumber - 1));
        const yearNumber = parseInt(selectedYear);
        dispatch(setSelectedMonthYear({ month: monthNumber, year: yearNumber }))
    }
    return (
        <div>
            <div className={`flex gap-x-10 justify-between items-center bg-gray-100 p-3 rounded-lg ${hideDatepicker && 'hidden'}`}>
                <Row className="justify-content-center">
                    <Col xs="auto" className="text-center">
                        <Breadcrumb className='mt-3'>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
                                Dashboard
                            </Breadcrumb.Item>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
                                Clients
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                linkAs={NavLink}
                                linkProps={{ to: `/clients/tax-forms/${client_id}` }}
                            >
                                Tax-Forms
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <div className="flex gap-x-10">
                    <DatePicker
                        className="min-w-[10rem]"
                        value={selectedYear ? dayjsPackage.year(selectedYear) : dayjsPackage}
                        disabled
                        picker="year"
                    />

                    <DatePicker
                        picker="month"
                        className="min-w-[10rem]"
                        format={"MMMM"}
                        onChange={handleMonthChange}
                        onKeyDown={(e) => e.preventDefault()}
                        value={selectedMonth}
                        disabledDate={disabledDate}
                    />
                    <button onClick={submitDate} className="bg-[#0d4473] px-4 rounded-sm text-white">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DatePickerComponent